import { GitSection } from "./GitSection";
import { SettingsPageContainer } from "./settingsLayout";

export function GitSettings() {
  return (
    <SettingsPageContainer>
      <GitSection />
    </SettingsPageContainer>
  );
}
